var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-1/4 cursor-pointer flex inputfloat clear-both text-gray-600 hover:text-gray-700"
  }, [_c('span', {
    staticClass: "minus-button"
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text text-base ml-3 mt-1.5 flex-initial"
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }